export default function SeoText() {
  return (
    <section id="sobre" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/518ad15ba79e4ed3a501931ef994c470.jpg"
              alt="Massagem relaxante Curitiba – Ambiente premium e discreto"
              className="w-full h-80 md:h-96 object-cover object-top rounded-2xl"
            />
          </div>

          <div>
            <span className="text-rose-400 text-sm font-semibold tracking-widest uppercase mb-3 block">Sobre o Serviço</span>
            <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Massagistas em Curitiba – <strong>Bem-Estar e Relaxamento</strong>
            </h2>
            <div className="space-y-4 text-stone-600 text-sm leading-relaxed">
              <p>
                O portal <strong>Massagistas.Online</strong> é a referência em <strong>massagistas em Curitiba</strong> e Região Metropolitana. Aqui você encontra profissionais especializadas em <strong>massagem relaxante Curitiba</strong>, massagem terapêutica e <strong>massagem tântrica Curitiba</strong> – com perfis verificados e fotos reais.
              </p>
              <p>
                Nossa seleção de <strong>massagistas verificadas em Curitiba</strong> conta com profissionais nos bairros de Batel, Centro, Água Verde, Portão, Rebouças, Bigorrilho, Santa Felicidade e em toda a região metropolitana como Pinhais, São José dos Pinhais, Colombo e Araucária.
              </p>
              <p>
                Cada massagista em Curitiba disponível na plataforma tem perfil completo com especialidades, horários de atendimento, localização e contato direto. Ideal para quem busca <strong>massagem com local Curitiba</strong>, ou seja, atendimento no próprio espaço da profissional.
              </p>
              <p>
                Priorizamos sua <strong>privacidade e segurança</strong>: todas as informações são tratadas com total discrição. Não há exposição de dados, e o contato é feito diretamente entre cliente e profissional.
              </p>
            </div>

            <a
              href="https://classivip.com/massagistas"
              target="_blank"
              rel="nofollow noopener"
              className="inline-flex items-center gap-2 mt-8 bg-stone-800 hover:bg-stone-900 text-white text-sm font-semibold px-7 py-3 rounded-full transition-colors whitespace-nowrap"
            >
              <i className="ri-external-link-line"></i>
              Ver perfis completos
            </a>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-rose-50 rounded-2xl p-8">
            <h3 className="text-lg font-bold text-stone-800 mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              <a href="#massagem-relaxante" className="hover:text-rose-500 transition-colors">
                <h4 id="massagem-relaxante">Massagem Relaxante em Curitiba</h4>
              </a>
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed">
              A <strong>massagem relaxante Curitiba</strong> é uma das mais procuradas da cidade. Técnica suave que alivia tensões musculares, reduz o estresse e promove sensação de leveza e bem-estar. Ideal para quem busca recarregar as energias no conforto de Curitiba.
            </p>
          </div>
          <div className="bg-stone-50 rounded-2xl p-8">
            <h3 className="text-lg font-bold text-stone-800 mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              <a href="#massagem-tantrica" className="hover:text-rose-500 transition-colors">
                <h4 id="massagem-tantrica">Massagem Tântrica em Curitiba</h4>
              </a>
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed">
              A <strong>massagem tântrica Curitiba</strong> vai além do físico: é uma experiência que une corpo, mente e energia. Profissionais especializadas oferecem essa modalidade com total respeito, discrição e um ambiente preparado especialmente para proporcionar equilíbrio e prazer.
            </p>
          </div>
          <div className="bg-rose-50 rounded-2xl p-8">
            <h3 className="text-lg font-bold text-stone-800 mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              <a href="#massagem-com-local" className="hover:text-rose-500 transition-colors">
                <h4 id="massagem-com-local">Massagem com Local em Curitiba</h4>
              </a>
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed">
              Procura <strong>massagem com local Curitiba</strong>? Diversas profissionais dispõem de espaço próprio para atendimento – ambiente higienizado, climatizado e preparado para sua comodidade e privacidade total.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
